import { LocationName, CaretDownIcon, LocationPickerContainer } from './styles';
import React from 'react';
import { useLocationPicker } from './use-location-picker.hook';
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BuildingIcon, ChevronDownIcon } from 'floorplan/pages/native-floorplan/components/icons';

interface LocationPickerProps {
  onClick: VoidFunction;
  locationName: string;
  isResourcesPage?: boolean;
  isFloorplanUi?: boolean;
}

export const LocationPicker = ({
  onClick,
  locationName,
  isResourcesPage,
  isFloorplanUi,
}: LocationPickerProps): JSX.Element => {
  useLocationPicker(locationName);
  return (
    <LocationPickerContainer
      data-testid="location-picker-component"
      onClick={onClick}
      isResourcesPage={isResourcesPage}
      isFloorplanUi={isFloorplanUi}
    >
      {isFloorplanUi ? <BuildingIcon /> : <FontAwesomeIcon icon={faMapMarkerAlt} size="1x" />}
      <LocationName>{locationName}</LocationName>
      {isFloorplanUi ? <ChevronDownIcon /> : <CaretDownIcon variant="adminBlack" className="caret" />}
    </LocationPickerContainer>
  );
};
